import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Bank, CreditCard, QrCode, Wallet } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const TYPE_META = {
  bank: { icon: Bank, color: 'bg-blue-50 text-blue-700 border-blue-200' },
  card: { icon: CreditCard, color: 'bg-purple-50 text-purple-700 border-purple-200' },
  upi: { icon: Wallet, color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  qr: { icon: QrCode, color: 'bg-pink-50 text-pink-700 border-pink-200' },
};

const PayoutMethodsCard = () => {
  const [methods, setMethods] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/api/payout-methods`);
        setMethods(res.data?.methods || []);
      } catch (e) { /* not a seller / no methods */ }
      finally { setLoaded(true); }
    })();
  }, []);

  if (!loaded || methods.length === 0) return null;

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5" data-testid="seller-payout-methods-card">
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="text-base font-bold text-slate-900">Payouts from Admin</h3>
          <p className="text-xs text-slate-500 mt-0.5">Your earnings will be transferred to you via one of these methods. Reach out to admin if you need a specific one.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {methods.map(m => {
          const meta = TYPE_META[m.type] || TYPE_META.bank;
          const Icon = meta.icon;
          return (
            <div key={m.method_id} data-testid={`payout-method-${m.method_id}`}
              className={`border rounded-xl p-3 flex items-start gap-3 ${meta.color}`}>
              <Icon size={22} weight="fill" />
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm truncate">{m.label}</div>
                <div className="text-[11px] mt-0.5 opacity-80 truncate">
                  {m.type === 'bank' && (<>{m.details?.bank_name && <>{m.details.bank_name} · </>}A/c ****{(m.details?.account || '').slice(-4)}{m.details?.ifsc && <> · {m.details.ifsc}</>}</>)}
                  {m.type === 'upi' && <>{m.details?.upi_id}</>}
                  {m.type === 'card' && <>{m.details?.hint}</>}
                  {m.type === 'qr' && m.qr_image_url && <a href={m.qr_image_url} target="_blank" rel="noopener noreferrer" className="underline">View QR</a>}
                </div>
                {m.instructions && <div className="text-[10px] mt-1 italic opacity-70">{m.instructions}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PayoutMethodsCard;
